import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateContactDataOfContact(contactData) {

    const updateContactData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateContactDetail", contactData);

      return updateContactData;
}